import { render, staticRenderFns } from "./pontos.vue?vue&type=template&id=77f08000"
import script from "./pontos.vue?vue&type=script&lang=js"
export * from "./pontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports